module.exports = __webpack_public_path__ + "img/pt-25.9ad9581e.jpg";